import { PermissionResource } from '@entities/client/permission';

import { requirePermission } from '../../../require-permission';

export const contractsLoader = requirePermission(PermissionResource.ClientContracts);
